import {Component, OnInit, ViewChild} from '@angular/core';
import {OrdersService} from '../../services/orders.service';
import {RoleService} from '../../../services/role.service';
import {CardReorder} from '../../../dto/cardReorder';
import {toCardExpireDateString} from '../../../providers/app-date-adapter';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {Observable} from 'rxjs';
import {CrudService} from '../../../services';
import {Card} from '../../../dto/card';
import {DataListModel} from '../../../models/data-list-model';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {Company} from '../../../dto/company';
import {CompanyService} from '../../services/company.service';
import {CardReorderReason} from '../../../dto/card-reorder-reason';
import {ReorderDelayReason} from '../../../dto/reorder-delay-reason';
import {AppMatCustomAction} from '../../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import {TrustPayTransaction} from '../../../dto/trustPayTransaction';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ToastService} from 'angular-toastify';

@Component({
  selector: 'app-reorders-queued',
  templateUrl: './reorders-queued.component.html',
  styleUrls: ['./reorders-queued.component.css']
})
export class ReordersQueuedComponent implements OnInit {


  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;
  dataSource = new MultiCrudDataSource(new ReorderCardsCrudContainer(this.ordersService));
  isBusy = false;

  constructor(
    private ordersService: OrdersService,
    private roleService: RoleService,
    private companyService: CompanyService,
    private dialog: MatDialog,
    private _toastService: ToastService,
  ) { }


  reorderCustomActions = [
    new AppMatCustomAction('check_circle_outline', 'Approve this Re-Order', false, (row: CardReorder) => {
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Approve',
          text: 'Are you sure you want to approve the re-order of '+ row.card.token +'?'
        },
        minWidth: 350,
      })
        .afterClosed()
        .subscribe(result => {
          if (result == 'ok') {
            this.approveReorder(row);
          }
        });
    }, row => row.isApproved, ),

  ];

  columns = [

    { columnDef: 'token', header: 'Token', cell: (row: CardReorder) => `${row.card.token}` },
    { columnDef: 'customerName', header: 'Name', cell: (row: CardReorder) => `${row.card.customer.firstName} ${row.card.customer.lastName}` },
    { columnDef: 'delayReason', header: 'Delay Reason', cell: (row: CardReorder) => {

        if ( row.delayReason === ReorderDelayReason.None ) {
          return 'None';
        }
        if ( row.delayReason === ReorderDelayReason.NoIdent ) {
          return 'No Ident';
        }
        if ( row.delayReason === ReorderDelayReason.OverdueInvoice ) {
          return 'Overdue Invoice';
        }
        if ( row.delayReason === ReorderDelayReason.AddressUnconfirmed ) {
          return 'Address unconfirmed';
        }
        if ( row.delayReason === ReorderDelayReason.MultipleReorders ) {
          return 'Multiple re-orders';
        }

        return '';

      } },
    { columnDef: 'delayComment', header: 'Delay Comment', cell: (row: CardReorder) => row.delayComment },
    { columnDef: 'product.name', header: 'Product', cell: (row: CardReorder) => `${row.card.productName}` },
    { columnDef: 'expireDate', header: 'Expiry Date', cell: (row: CardReorder) => `${toCardExpireDateString(row.card.expireDate)}` },
    { columnDef: 'reorderReason', header: 'Reason', cell: (row: CardReorder) => {
        if ( row.reorderReason === CardReorderReason.CardNotArrived ) {
          return 'Card not arrived';
        }
        if ( row.reorderReason === CardReorderReason.Expired ) {
          return 'Expired';
        }
        if ( row.reorderReason === CardReorderReason.ExpiringSoon ) {
          return 'Expiring soon';
        }
        if ( row.reorderReason === CardReorderReason.LostOrStolen ) {
          return 'Lost or stolen';
        }

        return '';

        }
      },
  ];

  getRowClass = (item: Card): string => {
    const classes = [];

    // TODO implement this if necessary
    return classes.join(' ');
  };
  getCustomerOverviewLink = (item: CardReorder): string => '/customers-overview/' + item.card.customerId.toString();
  companies: Company[] = [];


  ngOnInit(): void {

    this.companyService.getAll().subscribe(x => this.companies = x.data);

  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }

  private approveReorder(reorder: CardReorder) {

    this.ordersService.approveReorder(reorder.id).subscribe(x => {

      reorder.isApproved = true;
      //this.table.refreshTable();

      this._toastService.success('The reorder of ' + reorder.card.token + ' has been approved' );
      this.isBusy = false;

    }, err => {
      this.isBusy = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });


  }


}



export class ReorderCardsCrudContainer implements CrudService<CardReorder> {

  constructor(private ordersService: OrdersService) {

  }

  getMany(pageIndex: number, pageSize: number, sortField: string, sortDirection: string, filterString: string, dateFilterCols: string[], startFilterDate: Date, endFilterDate: Date, someAdditionalData: string, additionalFilterData?: string[], enumFilter?: { key: string; value: string }, companiesFilter?: string[], additionalField1?: string, additionalField2?: string, additionalValue1?: string, additionalValue2?: string, identStatusFilter?: string[]): Observable<DataListModel<CardReorder>> {
    return this.ordersService.getReordersQueued(pageIndex, pageSize, filterString);
  }

  get(id: any): Observable<CardReorder> {
    throw new Error('Method not implemented.');
  }
  add(item: CardReorder): Observable<any> {
    throw new Error('Method not implemented.');
  }
  update(id: any, item: CardReorder): Observable<any> {
    throw new Error('Method not implemented.');
  }
  delete(id: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  restore(id: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  deleteMany(list: any[]): Observable<any> {
    throw new Error('Method not implemented.');
  }
  restoreMany(list: any[]): Observable<any> {
    throw new Error('Method not implemented.');
  }

}

